module.exports = __webpack_public_path__ + "img/invoice.b8937d29.png";